import React from "react";
import "./App.css";
import { styled } from "./../styled";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import { theme } from "../theme";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	"@global": {
		'.MuiAutocomplete-option[aria-selected="true"]': {
			background: "#FFF",
		},
	},
});

const CustomFormControl = styled(({ formControlWidth, m, ...other }) => <FormControl {...other} />)({
	margin: (props) => theme.spacing(props.m),
	minWidth: 250,
	maxWidth: 370,
	flex: 1,
	width: (props) => props.formControlWidth,
});

const CustomFormLabel = styled(FormLabel)({
	marginBottom: 5,
	paddingBottom: 0,
	color: "black",
	fontSize: 14,
	paddingTop: 8,
	textDecoration: "none",
});

const CustomSelect = styled(Autocomplete)(({ selectvariant }) => ({
	...selectvariant,
	minWidth: "120px",
	// height: 40,
	marginTop: "0px !important",
	borderRadius: 20,
	// marginBottom: 8,
	// maxHeight: 28,
	color: "white !important",
	backgroundColor: "#FFF !important",
	textAlign: "left",
	"& input::placeholder": {
		color: "#FFF",
	},
}));

const CustomInput = styled(TextField)({
	color: `${theme.colors.mainGreen.secondary} !important`,
	backgroundColor: "#FFF",
	textAlign: "left",
	paddingLeft: 3,
	borderRadius: 20,
	paddingRight: 10,
	paddingLeft: 10,
	border: "1px solid",
	borderColor: theme.colors.mainGreen.secondary,
});

const CustomInputComponent = ({ params, classes, selectPlaceholder }) => {
	return (
		<div className='custom-autocomplete-input' ref={params.InputProps.ref}>
			<CustomInput id='custom-autocomplete-input' placeholder={selectPlaceholder} {...params} enabled={true} style={{ color: "white" }} type='text' />
		</div>
	);
};

const formControlLabelPlacementTop = {
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
};

const formLabelLabelPlacementTop = {
	marginBottom: 0,
	paddingRight: 8,
};

const variants = {
	darkGrey: {
		background: "#eceaf1",
	},
	lightGreen: {
		background: "transparent",
	},
	white: {
		background: "white",
	},
	noMargin: {
		margin: "0px !important",
		padding: "0px  !important",
		background: "transparent",
	},
};

const NonEmptySelect = ({ selectVariant, classes, disabled, ...rest }) => <CustomSelect classes={classes && classes} disabled={disabled} style={{ color: "white !important" }} variant='standard' renderInput={(params) => <CustomInputComponent classes={classes} params={params} />} selectvariant={variants[selectVariant]} {...rest} />;

const EmptySelect = ({ selectVariant, classes, selectPlaceholder, disabled, ...rest }) => <CustomSelect disabled={disabled} displayEmpty={true} renderInput={(params) => <CustomInputComponent selectPlaceholder={selectPlaceholder} classes={classes} params={params} />} selectvariant={variants[selectVariant]} {...rest} />;

export const SpAutocomplete = ({ label, labelPaddingTop, labelMarginBottom, classes, disabled, displayLabel = true, selectVariant = "lightGreen", formControlWidth, formControlStyle, labelPlacementLeft, selectPlaceholder = "", m = 1, ...rest }) => {
	useStyles();
	const localClasses = {};

	const controlStyle = {
		...formControlStyle,
		...(labelPlacementLeft && formControlLabelPlacementTop),
	};

	const labelStyle = labelPlacementLeft
		? formLabelLabelPlacementTop
		: {
				color: "black",
				paddingTop: labelPaddingTop ? labelPaddingTop : null,
				marginBottom: labelMarginBottom ? labelMarginBottom : null,
		  };
	return (
		<CustomFormControl formControlWidth={formControlWidth} style={controlStyle}>
			{displayLabel ? <CustomFormLabel style={labelStyle}>{label}</CustomFormLabel> : <></>}
			{rest.value && rest.value?.length !== 0 ? <NonEmptySelect loadingText={"Caricamento dati..."} disabled={disabled} classes={localClasses} selectVariant={selectVariant} {...rest} /> : <EmptySelect disabled={disabled} classes={localClasses} selectVariant={selectVariant} noOptionsText={"Nessun dato presente"} selectPlaceholder={selectPlaceholder} {...rest} />}
		</CustomFormControl>
	);
};
